export default {"src":"/_next/static/media/wish.b0a7483e.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};